import React,{useState} from 'react';
import Modal from "react-bootstrap/Modal";
import Wrp from '../../../hoc/Wrp/Wrp';
import { checkViolationsExist,getViolationsMsg,isSet, stringHasText } from '../../../Utils/CommonFunctions';
import Select from 'react-select';

const CreateExcel = (props) => {
	const {isCreateExcelModalOpen,toggleCreateExcelModel,saveExcelHandler,basicInfoChangeHandler,profileList,usersList,excelDetails,valueChangeHandlerWithName,violations,windowList,layoutList} = props;
	const {name,description,active,isDefault,profile_id,users,shared,layout_id,is_window,window_id, layoutName} = excelDetails;
    let profileOptions = [{label:'~None~',value:''}];
    if(profileList) {
        profileList.map(item => {
            profileOptions.push({label:item.profile_name,value:item.id});
        })
    }
    console.log(violations);
    const selectChangeHandler = (value,name) => {
        valueChangeHandlerWithName(name,value);
    }

    const handleInputChange = (val) => {
        let existVal = users ? users :[];
        existVal.push(val);
        valueChangeHandlerWithName('users',existVal);
    }

    const handleChange = (selectedOption) => {
        valueChangeHandlerWithName('users',selectedOption);
    }

    const handleDelete = (i) => {
        let existVal = users;
        existVal.splice(i,1);
        valueChangeHandlerWithName('users',existVal);
    }
    console.log(window_id);
	return(
		<Modal size="lg" show={isCreateExcelModalOpen} >
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2">Excel Template </h5>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
            		<div className="col-12">
                        <div className={checkViolationsExist('name',violations) === true ? "form-group has-error" : "form-group"}>
                            <label> XLs Template Name</label>
                            <input type="text" name="name" value={name} className="form-control mandatory" onChange={basicInfoChangeHandler}/>
                            { checkViolationsExist('name',violations) === true ? 
                                <label className="error m-0 text-wrap">{getViolationsMsg('name',violations)}</label>
                                : null
                            }
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label> Is Active </label>
                            <div className="material-switch p-2">
                                <input id="active" name="active" type="checkbox" checked={active} onChange={basicInfoChangeHandler}/>
                                <label htmlFor="active" className="secondary_bg"></label>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className={checkViolationsExist('default',violations) === true ? "form-group has-error" : "form-group"}>
                            <label> Set as Default </label> 
                            <div className="material-switch p-2">
                                <input id="isDefault" name="isDefault" type="checkbox" checked={isDefault} onChange={basicInfoChangeHandler}/>
                                <label htmlFor="isDefault" className="secondary_bg"></label>
                            </div>
                            { checkViolationsExist('default',violations) === true ? 
                                <label className="error m-0 text-wrap">{getViolationsMsg('default',violations)}</label>
                                : null
                            }
                        </div>
                    </div>
                    <div className="col-3">
                        <div className={checkViolationsExist('shared',violations) === true ? "form-group has-error" : "form-group"}>
                            <label> Sharing Permission </label>
                            <div className="material-switch p-2">
                                <input id="shared" name="shared" type="checkbox" checked={shared} onChange={basicInfoChangeHandler}/>
                                <label htmlFor="shared" className="secondary_bg"></label>
                            </div>
                            { checkViolationsExist('shared',violations) === true ? 
                                <label className="error m-0 text-wrap">{getViolationsMsg('shared',violations)}</label>
                                : null
                            }
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label> Is Window Field </label>
                            <div className="material-switch p-2">
                                <input id="is_window" name="is_window" type="checkbox" checked={is_window} onChange={basicInfoChangeHandler}/>
                                <label htmlFor="is_window" className="secondary_bg"></label>
                            </div>
                        </div>
                    </div>
                    {is_window === true ?
                    <Wrp>
                        <div className="col-6">
                            <div className="form-group">
                                <label> Window </label>
                                <div className="material-switch p-2">
                                    <select className="form-control" name="window_id" value={window_id} onChange={basicInfoChangeHandler} disabled={stringHasText(layoutName)?true:false}>
                                        <option value=""></option>
                                        {windowList && windowList.length>0 ?
                                            windowList.map((item,ind) => {
                                                return <option key={ind} value={item.value}>{item.name}</option>
                                            })
                                        : null}
                                    </select>
                                </div>
                            </div>
                        </div>
                        {!stringHasText(layoutName) && window_id && window_id !== "" ?
                            <div className="col-6">
                                <div className="form-group">
                                    <label> Layout </label>
                                    <div className="material-switch p-2">
                                        <select className="form-control" name="layout_id" value={layout_id} onChange={basicInfoChangeHandler}>
                                            <option value=""></option>
                                            {layoutList && layoutList.length>0 ?
                                                layoutList.map((item,ind) => {
                                                    return <option key={ind} value={item.value}>{item.name}</option>
                                                })
                                            : null}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        :stringHasText(layoutName)?
                        <div className="col-6">
                        <div className="form-group">
                            <label> Layout </label>
                            <div className="material-switch p-2">
                                <select className="form-control" name="layout_id" disabled={true} value={layoutName}>
                                 <option key={layoutName} value={layoutName}>{layoutName}</option>
                                </select>
                                   
                            </div>
                        </div>
                    </div>
                    :
                    null}
                    </Wrp>
                    : null}
                    { shared === true ?
                        <Wrp>
                            <div className="col-6">
                                <div className={checkViolationsExist('profile_id',violations) === true ? "form-group has-error" : "form-group"}>
                                    <label> Profiles to Share </label>
                                    <select className="form-control mandatory" name="profile_id" value={profile_id} onChange={basicInfoChangeHandler}>
                                    { profileOptions.map((item,ind) => {
                                            return <option value={item.value}>{item.label}</option>
                                        })}
                                    </select>
                                    { checkViolationsExist('profile_id',violations) === true ? 
                                        <label className="error m-0 text-wrap">{getViolationsMsg('profile_id',violations)}</label>
                                        : null
                                    }
                                </div>
                            </div>
                            { profile_id !== '' ?
                            <div className="col-6">
                                <div className="form-group">
                                    <label> Users to Share </label>
                                    <Select
                                        classNamePrefix="form-control"
                                        value={users}
                                        isMulti
                                        onChange={handleChange}
                                        options={usersList}
                                    />
                                </div>
                            </div>
                            : null}
                        </Wrp>
                    : null }
                    
                    <div className="col-12">
                        <div className="form-group">
                            <label> Description</label>
                            <textarea className="form-control" name="description" value={description} onChange={basicInfoChangeHandler}></textarea>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-between"> 
                <a onClick={toggleCreateExcelModel} className="btn btn-border border-default mr-2" data-dismiss="modal"> Cancel </a> 
                <a onClick={saveExcelHandler} className="btn primary_bg" data-dismiss="modal"> Save </a>                  
            </Modal.Footer>
		</Modal>
	)

}

export default CreateExcel;